import axios from "../config/axios";

export function apiSaveFeeDetail(data, id) {
	return axios.post(`fee-details/${id}`, data);
}
